export * from "./validatePhone.endpoint";
